import React, {Component} from 'react';
import PropTypes from 'prop-types';
import JobInputTitle from './JobInputTitle';
import JobListSelectField from './JobListSelectField';
import {sortArrayByKey} from '../shared/functions';
import FuseTheme from '../global/theme';
import {
    Table,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui';
import IconDelete from 'material-ui/svg-icons/action/delete';
import IconButton from 'material-ui/IconButton';

const listInputStyles = {
    container: {margin: '0 0 1em 0'},
    iconButton: {
        color: FuseTheme.palette.primary3Color,
        border: 8,
        padding: 10,
        width: 44,
        height: 44,
    },
    table: {border: '1px solid #e0e0e0', marginBottom: 10},
    tr: {height: 40},
    td: {height: 40}
};

class JobListInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addedIDs: [],
            addedItems: []
        };

        this.handleAddItem = this.handleAddItem.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.reset && !this.props.reset) {
            this.setState({
                addedIDs: [],
                addedItems: []
            });
        }
    }

    getAddedIDs() {
        return JSON.parse(JSON.stringify(this.state.addedIDs));
    }

    getAddedItems() {
        return JSON.parse(JSON.stringify(this.state.addedItems));
    }

    // Event: Select item, sort into lists, and notify form
    handleAddItem(type, selected) {
        if (selected && selected.id) {
            let addedIDs = this.getAddedIDs();
            let addedItems = this.getAddedItems();
            let idxIDs = addedIDs.findIndex(n => n === selected.id);
            let idxItems = addedItems.findIndex(n => n.id === selected.id);
            if (idxIDs === -1 && idxItems === -1) {
                addedIDs.push(selected.id);
                addedItems.push(selected);
                let sortedIDs = addedIDs.toSorted();
                let sortedItems = sortArrayByKey(addedItems, 'id', 'ASC');
                this.setState({
                    addedIDs: sortedIDs,
                    addedItems: sortedItems
                }, () => {
                    if (typeof this.props.onListUpdate === 'function') {
                        this.props.onListUpdate(this.props.customType, this.props.name, this.state.addedIDs);
                    }
                });
            }
        }
    }

    // Event: Remove item, update lists, and notify form
    handleRemoveItem(id) {
        let addedIDs = this.getAddedIDs();
        let addedItems = this.getAddedItems();
        let idxIDs = addedIDs.findIndex(n => n === id);
        let idxItems = addedItems.findIndex(n => n.id === id);
        if (idxIDs !== -1 && idxItems !== -1) {
            addedIDs.splice(idxIDs, 1);
            addedItems.splice(idxItems, 1);
            this.setState({
                addedIDs: addedIDs,
                addedItems: addedItems
            }, () => {
                if (typeof this.props.onListUpdate === 'function') {
                    this.props.onListUpdate(this.props.customType, this.props.name, this.state.addedIDs);
                }
            });
        }
    }

    renderItemRows = (list) => {
        const type = this.props.customType;

        if (!list || list.length === 0) {
            return (
                [0].map(() => (
                    <TableRow key={`no-${type}-items-added`} style={listInputStyles.tr}>
                        <TableRowColumn columnNumber={2} style={listInputStyles.td}>No {type} Added</TableRowColumn>
                    </TableRow>
                ))
            )
        }
        return (
            list.map((item, index) => (
                <TableRow key={`${type}-${item.id.toString()}`} style={listInputStyles.tr}>
                    <TableRowColumn style={listInputStyles.td}>{item.display_name}</TableRowColumn>
                    <TableRowColumn style={listInputStyles.td}>
                        <IconButton
                            style={listInputStyles.iconButton}
                            onClick={() => this.handleRemoveItem(item.id)}
                        >
                            <IconDelete/>
                        </IconButton>
                    </TableRowColumn>
                </TableRow>
            ))
        )
    };

    render() {
        const {
            customType,
            label,
            param,
            tooltip
        } = this.props;

        const {
            addedItems
        } = this.state;

        return (
            <div style={listInputStyles.container}>
                <JobInputTitle label={label} tooltip={tooltip}/>

                <JobListSelectField
                    label={label}
                    customType={customType}
                    param={param}
                    selectionType="object"
                    onSelectItem={this.handleAddItem}
                />

                <Table selectable={false} multiSelectable={false} style={listInputStyles.table}>
                    <TableBody displayRowCheckbox={false}>
                        {[...this.renderItemRows(addedItems)]}
                    </TableBody>
                </Table>
            </div>
        )
    }
}

JobListInput.propTypes = {
    customType: PropTypes.string,
    defaultValue: PropTypes.array,
    label: PropTypes.string,
    name: PropTypes.string,
    nativeType: PropTypes.string,
    onListUpdate: PropTypes.func,
    param: PropTypes.string,
    required: PropTypes.bool,
    reset: PropTypes.bool,
    tooltip: PropTypes.string
};

JobListInput.defaultProps = {
    defaultValue: [],
    name: 'locations',
    param: 'locations',
    nativeType: 'list',
    required: false,
    reset: false
};

export default JobListInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/JobListInput.js